/* tslint:disable */
/* eslint-disable */
export enum IncidentCauseCode {
  Medical = 'MEDICAL',
  Finddoctor = 'FINDDOCTOR',
  OnlineCare = 'ONLINE_CARE',
  Other = 'OTHER',
  Luggage = 'LUGGAGE'
}
